module.exports = __webpack_public_path__ + "img/social-media-display-honda.75d52fe3.png";